import { Flex } from "common/components/flex/flex";
import { DefaultColumnOptions } from "hooks/useDataGrid/options";
import K from "utilities/constants";
import { ExclamationTriangleIcon } from "features/dashboard/components/icons/ExclamationTriangle";
import { convertIntoDashUSFormat } from "utilities/dateUtility";

const requisitionAgingValueGetter = (params) => {
  const days = params.data.requisitionAging;
  if (days === undefined || days === null || days < 0) {
    return null;
  }
  return days;
};

const formatRequisitionAging = (days) => {
  if (days === null) {
    return K.NullPlaceholder;
  }
  return `${days} days`;
};

const getRequisitionAgingIcon = (isOverThreshold) => {
  if (!isOverThreshold) return null;

  return <ExclamationTriangleIcon style={{ marginLeft: 4, fontSize: 16 }} />;
};

const requisitionAgingRenderer = (params) => {
  const days = params.value;
  if (days === null) return formatRequisitionAging(days);

  const isOverThreshold = days > K.RequisitionAgingThreshold;
  const color = isOverThreshold
    ? K.DaysInStatusAlertLevelColors.critical
    : undefined;
  const icon = getRequisitionAgingIcon(isOverThreshold);

  return (
    <Flex
      align="center"
      justify="center"
      gap={4}
      style={{ width: "100%", color: color || "inherit" }}
    >
      {icon}
      <span>{formatRequisitionAging(days)}</span>
    </Flex>
  );
};

export const OpenPendingJobsColumns = [
  DefaultColumnOptions.Id,
  {
    headerName: "Job Status",
    field: "jobStatus.name",
  },
  {
    headerName: "Recruiting Start Date",
    field: "recruitingStartDate",
    headerTooltip: "Recruiting Start Date",
    sort: "asc",
    valueGetter: ({ data }) =>
      convertIntoDashUSFormat(data.recruitingStartDate, false),
    tooltipValueGetter: ({ value }) => value,
  },
  {
    headerName: "Requisition Aging",
    field: "requisitionAging",
    headerTooltip: "Requisition Aging",
    valueGetter: requisitionAgingValueGetter,
    cellRenderer: requisitionAgingRenderer,
    tooltipValueGetter: (params) => formatRequisitionAging(params.value),
  },
  {
    headerName: "Job Title",
    field: "title",
    tooltipField: "title",
  },
  {
    headerName: "Current Openings",
    field: "currentOpenings",
    headerTooltip: "Current Openings",
  },
  {
    headerName: "Job Location",
    field: "jobLocation.name",
    tooltipField: "jobLocation.name",
  },
  {
    headerName: "Job Department",
    field: "jobDepartment.name",
    headerTooltip: "Job Department",
    tooltipField: "jobDepartment.name",
  },
  {
    headerName: "Job Group",
    field: "jobGroup.name",
    tooltipField: "jobGroup.name",
  },
  {
    headerName: "ATS ID",
    field: "extAtsId",
  },
];
